import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderAdv3 = () => {
  return <header className="bg-white" data-id="element-2202">
      {/* Top black bar */}
      <div className="bg-black h-2 w-full" data-id="element-2203"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-3 sm:py-4" data-id="element-2204">
        <div className="text-center pb-2 sm:pb-3 mb-2 sm:mb-3" data-id="element-2205">
          <h2 className="font-serif text-xl sm:text-2xl font-bold tracking-tight text-gray-900" data-id="element-2206">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-1 font-medium" data-id="element-2207">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-2" data-id="element-2208">
          <div className="text-xs text-gray-400 font-sans" data-id="element-2209">Advertorial 3</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-t border-gray-300 pt-2 gap-1 sm:gap-0" data-id="element-2210">
          <div className="text-left" data-id="element-2211">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-2212">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-2213">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-4 border-b border-gray-200" data-id="element-2214">
        <div className="max-w-4xl mx-auto" data-id="element-2215">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium mb-3" data-id="element-2216">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-3xl font-bold text-gray-900 leading-tight mb-4" data-id="element-2217">
            How Retired Corning Specialist Re-Engineered Grounding Sheets Using 25-Year-Old
            Submarine Cable Technology
          </h1>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-4 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-2218">
            The engineering discovery that makes grounding sheets last for years
            while most sheets die after several washes
          </p>
          <div className="flex items-start mb-3 pb-3 border-b border-gray-200" data-id="element-2219">
            <div className="w-10 h-10 overflow-hidden rounded-full flex-shrink-0 mr-2 border border-gray-300" data-id="element-2220">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5V1KLd9diP6p4Lsag55oX2/YYkJmGMhE_ELwA2hWH_Ii.jpg" alt="Patricia Chen" className="w-full h-full object-cover" data-id="element-2221" />
            </div>
            <div className="flex-1" data-id="element-2222">
              <div className="flex items-center" data-id="element-2223">
                <div className="font-medium text-gray-900 text-sm" data-id="element-2224">
                  By Patricia Chen, RN, MSN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-2225">
                  <CheckCircleIcon className="h-3 w-3" data-id="element-2226" />
                  <span className="text-xs ml-1 font-medium" data-id="element-2227">Verified</span>
                </div>
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-2228">
                Former Head of Integrative Medicine, Cedar Sinai Medical Center
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-2229">
                <div className="flex items-center mr-4" data-id="element-2230">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-2231" />
                  <span data-id="element-2232">4 min read</span>
                </div>
                <div className="flex items-center" data-id="element-2233">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-2234" />
                  <span data-id="element-2235">24,867 views</span>
                </div>
              </div>
            </div>
          </div>
          <div className="text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-2236">
            <div className="flex items-center" data-id="element-2237">
              <span className="font-medium mr-2" data-id="element-2238">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="flex items-center" data-id="element-2239">
              <span className="font-medium mr-2" data-id="element-2240">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderAdv3;